<template>
  <div class="input-wrapper hd">
    <slot
      :condition="condition"
      :filterDownData="filterDownData"
      :pickerOptions="pickerOptions"
    />
    <el-button
      size="60"
      class="iconfont icon-sousuo"
      round
      @click="searchData"
    />
  </div>
</template>
<script>
import filterDownData from 'mixins/filterDownData'
import pickerOptions from 'mixins/pickerOptions/'

export default {
  name: 'SearchComponent',
  mixins: [filterDownData, pickerOptions],
  props: {
    condition: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    },
    activeName: {
      type: String
    }
  },
  methods: {
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchConditon()
      this.$emit('updateData', vm => {
        switch (this.routeName) {
          case 'distributorCheck':
            vm._getDistributorList({
              audit_status: vm.activeName,
              ...condition
            })
            break
          case 'distributorGoods':
            vm._getDistributorGoodsList({
              participation_status: vm.activeName === '1' ? '2' : '1',
              ...condition
            })
            break
          case 'commisionWithdrawal':
            vm._commissionWithdrawalList({
              audit_status: vm.activeName,
              ...condition
            })
            break
          case 'materialReview':
            vm._getMaterialList({
              audit_status: vm.activeName,
              ...condition
            })
            break
        }
      })
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchConditon() {
      const {
        name,
        time,
        attributionMerchant,
        level,
        checkType,
        goodsName,
        sku,
        startPrice,
        endPrice,
        goodsCategoray,
        storeCategoray,
        salesStatus,
        MaterialName,
        uploadTime,
        rules,
        address
      } = this.condition
      let data = {
        member_name: name,
        start_time: time && time[0],
        end_time: time && time[1],
        level_id: level,
        merchant_id: attributionMerchant,
        audit_type: checkType,
        goods_name: goodsName,
        goods_sku: sku,
        start_price: startPrice,
        end_price: endPrice,
        class_id: goodsCategoray ? goodsCategoray.slice(-1)[0] : '',
        merchant_class_id: storeCategoray ? storeCategoray.slice(-1)[0] : '',
        sales_status: salesStatus,
        meterial_name: MaterialName,
        distributor_name: name,
        add_time: uploadTime,
        size_name: rules,
        app_name: address
      }
      this.utils._checkSearchCondition(data)
      return data
    }
  }
}
</script>
